import { render, staticRenderFns } from "./RetrieveOrShopStatistic.vue?vue&type=template&id=7310d3cd&scoped=true&"
import script from "./RetrieveOrShopStatistic.vue?vue&type=script&lang=js&"
export * from "./RetrieveOrShopStatistic.vue?vue&type=script&lang=js&"
import style0 from "./RetrieveOrShopStatistic.vue?vue&type=style&index=0&id=7310d3cd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7310d3cd",
  null
  
)

export default component.exports